module.exports = __webpack_public_path__ + "img/Comercial.e191e9f6.png";